import fetcher from 'api/fetcher';
import { convertCentsToRubles } from 'utils/clickme';
import { HH_RU_PURCHASE_URL } from 'utils/constants/common';
import { NotificationName } from 'utils/constants/notification';

import { addNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

const makePurchaseUrl = (params: Record<string, string>): string => {
    const searchParams = new URLSearchParams(Object.entries(params));
    const url = new URL(HH_RU_PURCHASE_URL);
    url.search = searchParams.toString();
    return url.toString();
};

export const purchase =
    (amount: string, callback?: () => void): AppThunkAction =>
    async (dispatch) => {
        try {
            const { cartId } = await fetcher.post<unknown, { cartId: number }>('/api/v1/account/deposit', {
                amount: convertCentsToRubles(amount, 0),
            });

            const params = {
                cartId: String(cartId),
                httmFrom: 'clickme_invoice_create_hh',
            };

            const purchaseUrl = makePurchaseUrl(params);
            window.open(purchaseUrl, '_blank');

            if (callback) {
                callback();
            }
        } catch (_) {
            dispatch(addNotification(NotificationName.SomethingWentWrong));
        }
    };
